import { render, staticRenderFns } from "./Acfcta-Resources.vue?vue&type=template&id=49e76640&scoped=true&"
import script from "./Acfcta-Resources.vue?vue&type=script&lang=js&"
export * from "./Acfcta-Resources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e76640",
  null
  
)

export default component.exports